export default "__VITE_ASSET__B4D5xR6m__"